module.exports = __webpack_public_path__ + "img/23.d2c4b591.svg";